import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {removeAllEntities, removeEntity, setAllEntities, setEntity, withEntities} from '@ngrx/signals/entities';
import {LoRaGateway} from 'src/app/infrastructure/moovement-api/models/asset';

const initialState = {
  loading: true
};

export const GatewayStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withEntities<LoRaGateway>(),
  withMethods((store) => ({
    setAllEntities(gateways: LoRaGateway[]) {
      patchState(store, setAllEntities(gateways), { loading: false });
    },
    setEntity(gateway: LoRaGateway) {
      patchState(store, setEntity(gateway))
    },
    removeEntity(id: string) {
      patchState(store, removeEntity(id))
    },
    reset() {
      patchState(store, removeAllEntities(), initialState);
    }
  }))
);
